import { Directive, HostListener } from '@angular/core';


@Directive({
    selector: 'iframe'
})
export class IframeDirective {

    @HostListener('error', ['$event'])
    onError(event: ErrorEvent) {
        console.error(`Iframe error: ${event}`);
    }
}
